<!--
 * @Author: Ximen
 * @Date: 2021-03-23 19:40:08
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-06 16:52:36
-->
<template>
  <a-card class="box" style="width: 580px">
    <p class="title">付费记录</p>
    <div class="list-box">
      <ul>
        <li class="list" v-for="item in list" :key="item.siteId" @click="goToDetail(item)">
          <div class="left-box">
            <p class="p1">{{item.versionName}}/ {{item.cycle}}天</p>
            <p class="p2">{{item.createTime}}</p>
          </div>
          <div class="right-box">
            <p class="p1">{{item.payStatus==0?'未支付':'已支付'}}</p>
            <p class="p2">￥{{item.amount}}</p>
          </div>
        </li>
      </ul>
    </div>
  </a-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import commonApi from '@/api/common';
import moment from 'moment';

export default defineComponent({
  name: 'List',
  data() {
    const lists: Array<object> = [];
    return {
      list: lists,
    };
  },
  components: {
  },
  mounted() {
    this.getList();
  },
  methods: {
    goToDetail(item: Record<string, object>) {
      const parent = this.$parent as unknown as {[x: string]: Function};
      parent.openDetailModal(item);
    },
    getList() {
      interface Data{
        data: [];
        success: boolean;
        message: string;
      }
      commonApi.getSaasUpgradePayLists({}).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          interface Item{
            amount: number;
            createTime: string;
          }
          data.forEach((ele: Item) => {
            const item = ele;
            const amount = ele.amount.toFixed(2);
            item.amount = amount as any;
            item.createTime = moment(ele.createTime).format('YYYY-MM-DD HH:mm:ss');
            this.list.push(item);
          });
        } else {
          console.log(message);
        }
      });
    },
  },
});
</script>
<style lang="stylus" scoped>
    .box
      margin 0 auto
      border-radius 20px
      width 580px
      .title
        font-size 24px
        color #073D7D
        margin-bottom 40px
      .list-box
        width 100%
        height 300px
        overflow auto
        ul
          list-style-type none
          margin 0
          padding 0
          .list
            display flex
            flex-direction row
            justify-content space-between
            border-bottom 1px solid #D8D8D8
            padding 19px 0
            .left-box
              p
                margin 0
              .p1
                font-size 16px
                color #333
                text-align left
              .p2
                font-size 12px
                color #666
                text-align left
            .right-box
              p
                margin 0
              .p1
                font-size 16px
                color #FF0018
                text-align right
              .p2
                font-size 12px
                color #333
                text-align right
</style>
